var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Eleccion',{attrs:{"valor":_vm.modalidad,"titulo":"Elige la modalidad de pago que prefieres","opciones":_vm.opcionesModalidad},on:{"update:valor":function($event){return _vm.$emit('update:modalidad', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }